module.exports = __webpack_public_path__ + "static/img/en.06d49299.png";